import { ORDERS } from './feathers'

export const _fetchOrders = async () => {
  const { data } = await ORDERS.find()
  return data
}



